import { render } from "./circle-25.vue?vue&type=template&id=24c9578b&scoped=true"
import script from "./circle-25.vue?vue&type=script&lang=js"
export * from "./circle-25.vue?vue&type=script&lang=js"

import "./circle-25.vue?vue&type=style&index=0&id=24c9578b&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c9578b"]])

export default __exports__